import React, { Component } from 'react';
import SortSelect from './SortSelect';
import ListItem from './ListItem';
import RatioTable from '../RatioTable';
import { connect } from 'react-redux';
import { SortName } from '../../modelData';
import css from './style.css';
import cs from 'classnames';
import UnlockBtn from '~/components/common/UnlockEst';
import mapDispatch from "~/misc/mapDispatch";
import { modalChange } from "~/modules/modal/actions";

class index extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      sortName,
      sortBool,
      listData,
      sortClickHandler,
      itemClickhandel,
      showUpgradeToMember,
      tableLoading,
      isMember,
      currentItem
    } = this.props;

    return (
      <div className={css.RatioWarp}>
        <div className={css.ListWarp}>
          <div className={css.ListHeader}>
            {Object.values(SortName).map(item => (
              <SortSelect
                className={css.selectStyle}
                key={item}
                sortText={item}
                sortType={sortName === item ? sortBool : undefined}
                sortHandler={sortClickHandler(item)}
              />
            ))}
          </div>
          {!isMember && (
            <div className={css.Unlock}>
              Upgrade your account
              <UnlockBtn
                onClick={showUpgradeToMember}
              />
            </div>
          )}
          <div className={css.ListContent}>
            {listData.map(item => (
              <ListItem
                isActice={item.state === currentItem}
                state={item.state}
                inbound={item.in}
                intrastate={item.intrastate}
                outbound={item.out}
                itemClickhandel={itemClickhandel(item.state)}
                isMember={isMember}
              />
            ))}
          </div>
          <div className={css.ListBase}>
            <div>
              <span className={cs(css.iconCol, css.RedCol)} /> Above 2,000
            </div>
            <div>
              <span className={cs(css.iconCol, css.OraCol)} /> 1,001 - 2,000
            </div>
            <div>
              <span className={cs(css.iconCol, css.GreCol)} /> 501 - 1,000
            </div>
            <div>
              <span className={cs(css.iconCol, css.BulCol)} /> 100 - 501
            </div>
            <div>
              <span className={cs(css.iconCol, css.SkyCol)} /> Below 100
            </div>
          </div>
        </div>
        <RatioTable tableLoading={tableLoading} loadsSort={this.props.loadsSort} currentItem={currentItem} />
      </div>
    );
  }
}

export default connect(state => ({}),
  mapDispatch({
    showUpgradeToMember: (props) => modalChange('pop', {
      source: 'capacity-ratio-list',
      type: 'pop_upgrade_to_new_professional',
    }),
  })
)(index);



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioList/index.js